export default __webpack_public_path__ + "right-quotation-mark.png";